import React from 'react';

import { LogActions } from '@ariksa/notification/api';
import { HStack, Stack, Text } from '@chakra-ui/react';
import { each, filter, isEmpty } from 'lodash';
import map from 'lodash/map';

import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';
import { getAlertStatusMapping } from 'containers/Findings/AlertDrawer/Components/Aggregated/utils';
import { AlertStatus } from 'containers/Findings/FindingsOverview/Components/AlertTables/Components/AlertStatus';

import { toTitleCase } from '../../../../../../utils/string';

export const renderAlertsStatusHeader = () => (
  <CustomTooltip
    label={
      <Stack>
        <HStack justify={'center'}>
          <Text>Status</Text>
        </HStack>
        <HStack>
          <Text color="orange">To do</Text>
          <Text>- Issue raised</Text>
        </HStack>
        <HStack>
          <Text color="orange">Open</Text>
          <Text>- Ticket created</Text>
        </HStack>
        <HStack>
          <Text color="orange">In progress </Text>
          <Text>- Ticket WIP</Text>
        </HStack>
      </Stack>
    }
  >
    Status
  </CustomTooltip>
);

export const renderAlertsStatus = tickets => {
  const visibleTickets = filter(tickets, t => {
    return t.action !== 'slack';
  });
  let actions = new Set<string>();
  each(visibleTickets, o => {
    if (o.action === LogActions.Jira || o.action === LogActions.Servicenow)
      actions.add(o.action);
  });

  return isEmpty(visibleTickets) ? (
    <AlertStatus status={'To Do'} />
  ) : (
    <CustomTooltip
      label={
        <Stack spacing={1}>
          {map(visibleTickets, (ticket, k) => (
            <AlertStatus
              status={getAlertStatusMapping(ticket.ticket_status ?? 'todo')}
            />
          ))}
        </Stack>
      }
    >
      <Stack spacing={1}>
        {map(visibleTickets, (ticket, k) => (
          <AlertStatus
            status={getAlertStatusMapping(ticket.ticket_status ?? 'To Do')}
          />
        ))}
        <HStack>
          {map(actions, o => (
            <Text>{toTitleCase(o)}</Text>
          ))}
        </HStack>
      </Stack>
    </CustomTooltip>
  );
};
